import React from 'react';

import { TextAreaProps } from 'antd/lib/input';

import * as Styled from './TextArea.style';

export type Props = TextAreaProps;

export const TextArea = (props: Props): JSX.Element => <Styled.StyledTextArea {...props} />;
